import React from 'react';
import { useTranslation } from 'react-i18next';

const SEOContent: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section id="seo-content" className="py-8 sm:py-12 md:py-16 px-3 sm:px-4 md:px-6 lg:px-8 bg-dark-800 overflow-x-hidden border-b border-white/5">
      <div className="max-w-7xl mx-auto w-full">
        <div className="space-y-6 sm:space-y-8 md:space-y-12">
          {/* Why Choose Section */}
          <div className="bg-dark-800 border border-dark-700 rounded-lg sm:rounded-xl p-4 sm:p-6 lg:p-8">
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-white mb-3 sm:mb-4 md:mb-6">
              {t('landing.seoContent.whyChoose')}
            </h2>
            <div className="prose prose-invert max-w-none">
              <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed mb-3 sm:mb-4">
                {t('landing.seoContent.whyChooseDesc1')}
              </p>
              <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed mb-3 sm:mb-4">
                {t('landing.seoContent.whyChooseDesc2')}
              </p>
            </div>
          </div>

          {/* A Large and Varied Selection of Slot Games */}
          <div className="bg-dark-800 border border-dark-700 rounded-lg sm:rounded-xl p-4 sm:p-6 lg:p-8">
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-white mb-3 sm:mb-4 md:mb-6">
              {t('landing.seoContent.largeVariety')}
            </h2>
            <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed mb-4 sm:mb-6 md:mb-8">
              {t('landing.seoContent.largeVarietyDesc')}
            </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-6">
              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6 hover:border-primary-500 transition-colors duration-300">
                <div className="w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-yellow-500/20 rounded-md sm:rounded-lg flex items-center justify-center mb-2 sm:mb-3 md:mb-4">
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                </svg>
              </div>
                <h3 className="text-sm sm:text-base md:text-xl font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.progressiveJackpots')}</h3>
              <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.progressiveJackpotsDesc')}
              </p>
            </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6 hover:border-primary-500 transition-colors duration-300">
              <div className="w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-blue-500/20 rounded-md sm:rounded-lg flex items-center justify-center mb-2 sm:mb-3 md:mb-4">
                <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                </div>
                <h3 className="text-sm sm:text-base md:text-xl font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.classicStyles')}</h3>
                <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.classicStylesDesc')}
                </p>
              </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6 hover:border-primary-500 transition-colors duration-300">
                <div className="w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-green-500/20 rounded-md sm:rounded-lg flex items-center justify-center mb-2 sm:mb-3 md:mb-4">
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-sm sm:text-base md:text-xl font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.modernFiveReel')}</h3>
              <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.modernFiveReelDesc')}
              </p>
            </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6 hover:border-primary-500 transition-colors duration-300">
              <div className="w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-purple-500/20 rounded-md sm:rounded-lg flex items-center justify-center mb-2 sm:mb-3 md:mb-4">
                <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </div>
                <h3 className="text-sm sm:text-base md:text-xl font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.videoSlots')}</h3>
              <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.videoSlotsDesc')}
              </p>
            </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6 hover:border-primary-500 transition-colors duration-300">
                <div className="w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-red-500/20 rounded-md sm:rounded-lg flex items-center justify-center mb-2 sm:mb-3 md:mb-4">
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                </svg>
                </div>
                <h3 className="text-sm sm:text-base md:text-xl font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.themedGames')}</h3>
                <p className="text-gray-300 text-xs sm:text-sm leading-relaxed mb-2 sm:mb-3">
                  {t('landing.seoContent.themedGamesDesc')}
                </p>
                <ul className="text-gray-300 text-xs sm:text-sm space-y-1 list-disc list-inside">
                  <li>{t('landing.seoContent.themedGamesList1')}</li>
                  <li>{t('landing.seoContent.themedGamesList2')}</li>
                  <li>{t('landing.seoContent.themedGamesList3')}</li>
                  <li>{t('landing.seoContent.themedGamesList4')}</li>
                </ul>
              </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6 hover:border-primary-500 transition-colors duration-300">
                <div className="w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-indigo-500/20 rounded-md sm:rounded-lg flex items-center justify-center mb-2 sm:mb-3 md:mb-4">
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 4v16M17 4v16M3 8h4m10 0h4M3 12h18M3 16h4m10 0h4M4 4h4v16H4V4zm12 0h4v16h-4V4z" />
                  </svg>
                </div>
                <h3 className="text-sm sm:text-base md:text-xl font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.brandedSlots')}</h3>
              <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.brandedSlotsDesc')}
                </p>
              </div>
            </div>
          </div>

          {/* Free Play or Real Money */}
          <div className="bg-dark-800 border border-dark-700 rounded-lg sm:rounded-xl p-4 sm:p-6 lg:p-8">
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-white mb-3 sm:mb-4 md:mb-6">
              {t('landing.seoContent.freePlayOrRealMoney')}
            </h2>
            <div className="prose prose-invert max-w-none">
              <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed mb-3 sm:mb-4">
                {t('landing.seoContent.freePlayDesc1')}
              </p>
              <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed">
                {t('landing.seoContent.freePlayDesc2')}
              </p>
            </div>
          </div>

          {/* Bonuses and Promotions */}
          <div className="bg-dark-800 border border-dark-700 rounded-lg sm:rounded-xl p-4 sm:p-6 lg:p-8">
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-white mb-3 sm:mb-4 md:mb-6">
              {t('landing.seoContent.bonusesPromotions')}
            </h2>
            <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed mb-4 sm:mb-6 md:mb-8">
              {t('landing.seoContent.bonusesDesc')}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-6">
              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6">
                <h3 className="text-sm sm:text-base md:text-lg font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.freeSpins')}</h3>
                <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.freeSpinsDesc')}
                </p>
              </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6">
                <h3 className="text-sm sm:text-base md:text-lg font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.welcomeOffers')}</h3>
                <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.welcomeOffersDesc')}
              </p>
            </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6">
                <h3 className="text-sm sm:text-base md:text-lg font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.noDepositBonuses')}</h3>
                <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.noDepositBonusesDesc')}
                </p>
              </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6">
                <h3 className="text-sm sm:text-base md:text-lg font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.bonusCodes')}</h3>
              <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.bonusCodesDesc')}
              </p>
            </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6">
                <h3 className="text-sm sm:text-base md:text-lg font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.regularPromotions')}</h3>
                <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.regularPromotionsDesc')}
                </p>
              </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6">
                <h3 className="text-sm sm:text-base md:text-lg font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.cashback')}</h3>
              <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.cashbackDesc')}
              </p>
              </div>
            </div>
          </div>

          {/* Play on Any Device */}
          <div className="bg-dark-800 border border-dark-700 rounded-lg sm:rounded-xl p-4 sm:p-6 lg:p-8">
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-white mb-3 sm:mb-4 md:mb-6">
              {t('landing.seoContent.playAnyDevice')}
            </h2>
            <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed mb-4 sm:mb-6 md:mb-8">
              {t('landing.seoContent.playAnyDeviceDesc')}
            </p>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4 md:gap-6">
              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6">
                <h3 className="text-xs sm:text-sm md:text-lg font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.mobileSlots')}</h3>
                <p className="text-gray-300 text-[10px] sm:text-xs md:text-sm leading-relaxed">
                  {t('landing.seoContent.mobileSlotsDesc')}
                </p>
              </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6">
                <h3 className="text-xs sm:text-sm md:text-lg font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.androidIos')}</h3>
                <p className="text-gray-300 text-[10px] sm:text-xs md:text-sm leading-relaxed">
                  {t('landing.seoContent.androidIosDesc')}
                </p>
              </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6">
                <h3 className="text-xs sm:text-sm md:text-lg font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.desktopPlay')}</h3>
                <p className="text-gray-300 text-[10px] sm:text-xs md:text-sm leading-relaxed">
                  {t('landing.seoContent.desktopPlayDesc')}
                </p>
              </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6">
                <h3 className="text-xs sm:text-sm md:text-lg font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.instantPlay')}</h3>
                <p className="text-gray-300 text-[10px] sm:text-xs md:text-sm leading-relaxed">
                  {t('landing.seoContent.instantPlayDesc')}
                </p>
              </div>
            </div>
          </div>

          {/* Crypto, Social & New-Generation Slot Experiences */}
          <div className="bg-dark-800 border border-dark-700 rounded-lg sm:rounded-xl p-4 sm:p-6 lg:p-8">
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-white mb-3 sm:mb-4 md:mb-6">
              {t('landing.seoContent.cryptoSocial')}
            </h2>
            <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed mb-4 sm:mb-6 md:mb-8">
              {t('landing.seoContent.cryptoSocialDesc')}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-6">
              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6">
                <h3 className="text-sm sm:text-base md:text-lg font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.cryptoFriendlySlots')}</h3>
                <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.cryptoFriendlySlotsDesc')}
                </p>
              </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6">
                <h3 className="text-sm sm:text-base md:text-lg font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.bitcoinGames')}</h3>
                <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.bitcoinGamesDesc')}
                </p>
              </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6">
                <h3 className="text-sm sm:text-base md:text-lg font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.liveDealerSlots')}</h3>
                <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.liveDealerSlotsDesc')}
                </p>
              </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6">
                <h3 className="text-sm sm:text-base md:text-lg font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.socialSlots')}</h3>
                <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.socialSlotsDesc')}
                </p>
              </div>

              <div className="bg-dark-700 border border-dark-600 rounded-lg p-3 sm:p-4 md:p-6">
                <h3 className="text-sm sm:text-base md:text-lg font-bold text-white mb-1 sm:mb-2 md:mb-3">{t('landing.seoContent.vrSlots')}</h3>
                <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  {t('landing.seoContent.vrSlotsDesc')}
                </p>
              </div>
            </div>
          </div>

          {/* A Safe Place to Play and Explore */}
          <div className="bg-dark-800 border border-dark-700 rounded-lg sm:rounded-xl p-4 sm:p-6 lg:p-8">
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-white mb-3 sm:mb-4 md:mb-6">
              {t('landing.seoContent.safePlace')}
            </h2>
            <div className="prose prose-invert max-w-none">
              <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed mb-3 sm:mb-4">
                {t('landing.seoContent.safePlaceDesc1')}
              </p>
              <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed mb-3 sm:mb-4">
                {t('landing.seoContent.safePlaceDesc2')}
              </p>
              <ul className="text-gray-300 text-sm sm:text-base md:text-lg space-y-1 sm:space-y-2 list-disc list-inside mb-3 sm:mb-4">
                <li>{t('landing.seoContent.safePlaceList1')}</li>
                <li>{t('landing.seoContent.safePlaceList2')}</li>
                <li>{t('landing.seoContent.safePlaceList3')}</li>
                <li>{t('landing.seoContent.safePlaceList4')}</li>
                <li>{t('landing.seoContent.safePlaceList5')}</li>
              </ul>
              <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed">
                {t('landing.seoContent.safePlaceDesc3')}
              </p>
            </div>
          </div>

          {/* Start Playing Today */}
          <div className="bg-gradient-to-r from-primary-600 to-primary-700 border border-primary-500 rounded-lg sm:rounded-xl p-4 sm:p-6 lg:p-8 text-center">
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-white mb-2 sm:mb-3 md:mb-4">
              {t('landing.seoContent.startPlaying')}
            </h2>
            <p className="text-gray-100 text-sm sm:text-base md:text-lg leading-relaxed mb-3 sm:mb-4 md:mb-6 max-w-3xl mx-auto">
              {t('landing.seoContent.startPlayingDesc1')}
            </p>
            <p className="text-gray-100 text-sm sm:text-base md:text-lg leading-relaxed">
              {t('landing.seoContent.startPlayingDesc2')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SEOContent;
